import amplitude, { AmplitudeProps } from './sources/amplitude';
import datadog, { DataDogConfig } from './sources/datadog';
import experiment from './sources/experiment';
import gtm, { GoogleTagManagerConfig } from './sources/gtm';
import segment, { SegmentProps } from './sources/segment';
import sentry, { SentryConfig } from './sources/sentry';
import whoopUserEventTracker from './sources/whoop-analytics';

import {
  AnalyticsContext,
  UserProfile,
  InitializeFunction,
  IdentifyFunction,
  EventFunction,
  AnalyticsSource,
  WhoopAnalytics,
  UserEventTrackerProps,
  RouteChangeTrackerProps,
} from './types';

interface WebAnalyticsProps {
  amplitude?: AmplitudeProps;
  datadog?: DataDogConfig;
  gtm?: GoogleTagManagerConfig;
  segment?: SegmentProps;
  sentry?: SentryConfig;
}

export default {
  initialize: ({
    amplitude: amplitudeProps,
    datadog: datadogProps,
    gtm: gtmProps,
    segment: segmentProps,
    sentry: sentryProps,
  }) => {
    if (amplitudeProps) {
      amplitude.initialize(amplitudeProps);
    }

    if (datadogProps) {
      datadog.initialize(datadogProps);
    }

    if (gtmProps) {
      gtm.initialize(gtmProps);
    }

    if (segmentProps) {
      segment.initialize(segmentProps);
    }

    if (sentryProps) {
      sentry.initialize(sentryProps);
    }
  },
  identify: (user) => {
    if (segment.identify) {
      segment.identify(user);
    }
  },
  trackAmplitudeEvent: (eventName, context) => {
    if (amplitude.trackEvent) {
      amplitude.trackEvent(eventName, context);
    }
  },
  trackError: (err) => {
    if (sentry.trackError) {
      sentry.trackError(err);
    }
  },
  trackSegmentEvent: (eventName, context) => {
    if (segment.trackEvent) {
      segment.trackEvent(eventName, context);
    }
  },
  getVariant: (experimentName, filters) =>
    experiment.getVariant(experimentName, filters),
  registerUserEventTracker: (props: UserEventTrackerProps) => {
    whoopUserEventTracker.registerUserEventTracker(props);
  },
  notifyRouteChange: (props: RouteChangeTrackerProps) => {
    whoopUserEventTracker.notifyRouteChange(props);
  },
  trackPageView: (context) => {
    gtm.trackPageView(context);
  },
  trackPurchase: (context) => {
    gtm.trackPurchase(context);
  },
  trackGoogleEvent: (eventName, context) => {
    gtm.trackGoogleEvent(eventName, context);
  },
} as WhoopAnalytics<WebAnalyticsProps>;

// Type Exports
export {
  AnalyticsContext,
  UserProfile,
  InitializeFunction,
  IdentifyFunction,
  EventFunction,
  AnalyticsSource,
  WhoopAnalytics,
  WebAnalyticsProps,
  SegmentProps,
  DataDogConfig,
  SentryConfig,
  AmplitudeProps,
  GoogleTagManagerConfig,
};
